import api from "Helpers/Api";
import { IArticle } from "Services/Article/article";

export default async function articlesCreate(params: IArticle) {
  const { data } = await api.post(`/articles/create`, params);

  return data;
}
